declare const __MAPLE_BUILD__: { revision: string; builtAt: string }

export const buildInfo = typeof __MAPLE_BUILD__ === 'undefined'
  ? { revision: 'development', builtAt: null }
  : __MAPLE_BUILD__
